import React from 'react';
import { MenuItem, TextField, ToggleButton, ToggleButtonGroup, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMap from './useMap';
function MapTypeSelector({ on3dSelected }) {
    const { setMapTypeId } = useMap();
    const theme = useTheme();
    const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const handleChange = (newValue) => {
        if (newValue === '3d' && on3dSelected) {
            on3dSelected();
        }
        else {
            setMapTypeId?.(newValue);
        }
    };
    if (isBigScreen) {
        return (React.createElement(ToggleButtonGroup, { color: "primary", exclusive: true, onChange: (_, newValue) => handleChange(newValue), sx: { backgroundColor: theme.palette.background.paper } },
            React.createElement(ToggleButton, { value: "hybrid", sx: { p: 1 / 2 } }, "Satellite"),
            React.createElement(ToggleButton, { value: "roadmap", sx: { p: 1 / 2, minWidth: 52 } }, "Map"),
            on3dSelected ? (React.createElement(ToggleButton, { value: "3d", sx: { p: 1 / 2, minWidth: 52 } }, "3D")) : null));
    }
    return (React.createElement(TextField, { select: true, color: "primary", defaultValue: "roadmap", onChange: (event) => handleChange(event.target.value), sx: {
            backgroundColor: theme.palette.background.paper,
            '& .MuiInputBase-input': {
                fontSize: '0.8rem',
                p: 1,
            },
        } },
        React.createElement(MenuItem, { value: "hybrid" }, "Satellite"),
        React.createElement(MenuItem, { value: "roadmap" }, "Map"),
        on3dSelected ? React.createElement(MenuItem, { value: "3d" }, "3D") : null));
}
export default MapTypeSelector;
